import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Filters from './Filters';
import Table from './Table';
import { selectTransactionTab } from '../../store/actions/transaction.actions';
import { Translate } from '../../localization';

const Transactions = (props) => {
    const [isActive, setIsActive] = useState('casino');
    const { language } = useSelector((state) => state.general);
    const userData = useSelector((state) => state.user.data);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(selectTransactionTab(isActive));
    }, [language]);

    const setActiveTab = (tab) => {
        setIsActive(tab);
        dispatch(selectTransactionTab(tab));
    };

    return (
        <>
            <div className="main-container mybet" >
                <Grid container className="mybet__result">
                    <Grid item xs={3} className={`${isActive === 'casino' ? 'active' : ''}`} onClick={(e) => setActiveTab('casino')}>
                        Casino
                    </Grid>
                    <Grid item xs={3} className={`${isActive === 'live casino' ? 'active' : ''}`} onClick={(e) => setActiveTab('live casino')}>
                        Live Casino
                    </Grid>
                    {userData && userData?.is_coins_payment_enabled && <Grid item xs={5} className={`${isActive === 'coin payments' ? 'active' : ''}`} onClick={(e) => setActiveTab('coin payments')}>
                        {Translate.coinPayments}
                    </Grid>}
                </Grid>
                <Filters tab={isActive} language={language} />
                <Table tab={isActive} />
            </div>
        </>
    );
};

export default Transactions;